module.exports = __webpack_public_path__ + "static/media/modal-alert-icon.a197aa77.svg";